// Near/far clip planes shared by every camera-like object in this editor —
// split out from sceneGraph.js so projection.js (which sceneGraph.js itself
// imports from, for applyProjectionsToMaterial) can use the same values
// without the two files importing each other. Not user-facing — the editor
// only cares about "doesn't clip anything at scene scale", not precise
// depth-buffer tuning.
export const CAMERA_NEAR = 0.1;
export const CAMERA_FAR = 10000;
